export default __webpack_public_path__ + "static/media/logo-horiz-alt.fa844b80.svg";